/**
 * Manifest of every flag HealthOS evaluates. Server and client SDKs both
 * reference this object so flag keys and defaults stay aligned across runtimes.
 *
 * Add a new flag here, then expose a typed accessor in `./server/index.ts`
 * and (if needed) `./client/index.ts`.
 *
 * Company-scoped accessors pass `companyConfigCatUser` from `./server/index.ts`.
 * Target new company flags on the custom attribute `companyId`. Identifier
 * stays the company UUID so existing Identifier rules keep matching.
 */
export const FLAGS = {
    enableTweaksPanel: {
        key: "enableTweaksPanel",
        default: false,
    },
    /**
     * The Outlook Calendar connector inside Microsoft Teams (personal connect +
     * tenant admin-consent). Default off: the integration isn't production-ready
     * yet, so the ops org-integrations card must stay in its catalog "on the way"
     * state with no manage controls until a tenant is explicitly opted in.
     * `companyConfigCatUser` sends the company UUID as Identifier and as the
     * `companyId` custom attribute.
     */
    enableMsTeamsCalendarIntegration: {
        key: "enableMsTeamsCalendarIntegration",
        default: false,
    },
    /**
     * The web dark theme and the Settings > Appearance picker that chooses it.
     * Default off: members see the light theme until opted in. Member-scoped:
     * Identifier is the user id, and `companyId` rides along as a custom
     * attribute when the caller's token carries one, so a rollout can target
     * either a person or a whole company.
     */
    enableDarkMode: {
        key: "enableDarkMode",
        default: false,
    },
};
//# sourceMappingURL=index.js.map